<template>
  <div class="page">
    <h2 class="page-title">问题反馈</h2>
    <div class="filter-card">
      <el-form :model="query" size="small" label-width="72px" class="filter-form">
        <el-row :gutter="12">
          <el-col :xl="5" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="反馈类型">
              <el-select v-model="query.type" placeholder="全部类型" clearable>
                <el-option v-for="t in typeOptions" :key="t.value" :label="t.label" :value="t.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="7" :md="8" :sm="12" :xs="24">
            <el-form-item label="关键词"><el-input v-model="query.keyword" placeholder="反馈内容/联系方式" clearable /></el-form-item>
          </el-col>
          <el-col :xl="8" :lg="9" :md="12" :sm="24" :xs="24">
            <el-form-item label="提交时间">
              <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" clearable />
            </el-form-item>
          </el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item class="filter-actions">
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-card">
      <div class="table-toolbar">
        <el-button size="small" @click="exportList">导出</el-button>
      </div>
      <el-table :data="tableData" v-loading="loading" border>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column label="类型" width="110">
          <template slot-scope="scope">
            <el-tag :type="typeTagType(scope.row.type)" size="small">{{ scope.row.type || '-' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="反馈内容" min-width="280" show-overflow-tooltip />
        <el-table-column label="提交人" min-width="150">
          <template slot-scope="scope">
            <div class="user-cell">
              <el-avatar :size="32" :src="resolveAvatarUrl(scope.row.userAvatar)" icon="el-icon-user-solid" />
              <span class="main-text">{{ scope.row.userName || '-' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="contact" label="联系方式" min-width="130" show-overflow-tooltip />
        <el-table-column label="图片" width="90">
          <template slot-scope="scope">
            <el-image v-if="scope.row.images && scope.row.images.length" :src="resolveImageUrl(scope.row.images[0])" :preview-src-list="resolveImageList(scope.row.images)" style="width:40px;height:40px;border-radius:4px" fit="cover" />
            <span v-else class="empty-tip">无</span>
          </template>
        </el-table-column>
        <el-table-column label="提交时间" width="170">
          <template slot-scope="scope">{{ formatDateTime(scope.row.createdAt) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="90" fixed="right">
          <template slot-scope="scope">
            <span class="action-text delete" @click="handleDelete(scope.row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next, total" :total="total" :current-page.sync="query.pageNum" :page-size="query.pageSize" @current-change="loadData" style="margin-top:16px;text-align:right" />
    </div>
  </div>
</template>

<script>
import { fetchFeedbacks, deleteFeedback } from '@/api'
import { resolveImageUrl, resolveImageList } from '@/utils/media'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      dateRange: [],
      typeOptions: [
        { value: '故障上报', label: '故障上报' },
        { value: '改进建议', label: '改进建议' },
        { value: '其他', label: '其他' }
      ],
      query: { pageNum: 1, pageSize: 10, keyword: '', type: '' }
    }
  },
  created() { this.loadData() },
  methods: {
    resolveImageUrl,
    resolveImageList,
    resolveAvatarUrl(url) {
      return url ? resolveImageUrl(url) : ''
    },
    typeTagType(type) {
      if (type === '故障上报') return 'danger'
      if (type === '改进建议') return 'success'
      return 'info'
    },
    async loadData() {
      this.loading = true
      try {
        const params = { ...this.query }
        if (this.dateRange && this.dateRange.length === 2) {
          params.startTime = this.dateRange[0]
          params.endTime = this.dateRange[1]
        }
        Object.keys(params).forEach(k => { if (params[k] === '' || params[k] === null || params[k] === undefined) delete params[k] })
        const res = await fetchFeedbacks(params)
        this.tableData = res.records || []
        this.total = res.total || 0
      } finally { this.loading = false }
    },
    handleSearch() { this.query.pageNum = 1; this.loadData() },
    handleReset() {
      this.dateRange = []
      this.query = { pageNum: 1, pageSize: 10, keyword: '', type: '' }
      this.loadData()
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该条反馈吗？', '删除确认', { type: 'warning' })
        await deleteFeedback(row.id)
        this.$message.success('已删除')
        this.loadData()
      } catch (e) {}
    },
    exportList() {
      const headers = ['ID', '类型', '反馈内容', '提交人', '联系方式', '提交时间']
      const rows = this.tableData.map(r => [r.id, r.type, r.content, r.userName, r.contact, this.formatDateTime(r.createdAt)])
      const csv = [headers, ...rows].map(items => items.map(v => `"${String(v == null ? '' : v).replace(/"/g, '""')}"`).join(',')).join('\n')
      const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `问题反馈_${new Date().toISOString().slice(0, 10)}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    },
    formatDateTime(v) { return v ? String(v).replace('T', ' ') : '-' }
  }
}
</script>

<style scoped>
.user-cell { display: flex; align-items: center; gap: 10px; }
.main-text { color: #333; font-weight: 600; line-height: 20px; }
.filter-form ::v-deep .el-row { width: 100%; }
.filter-form ::v-deep .el-form-item { margin-bottom: 12px; }
.filter-form ::v-deep .el-input,
.filter-form ::v-deep .el-select,
.filter-form ::v-deep .el-date-editor { width: 100%; }
.filter-form ::v-deep .filter-actions .el-form-item__content { display: flex; gap: 8px; }
.table-toolbar { display: flex; justify-content: flex-end; gap: 10px; margin-bottom: 12px; }
.action-text { cursor: pointer; font-size: 13px; }
.action-text:hover { text-decoration: underline; }
.action-text.delete { color: #f56c6c; }
.empty-tip { color: #999; }
</style>
